import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { Helmet } from "react-helmet";

const Chapters = () => {
    const [MangaFiltred, setMangaFiltred] = useState(null);
    let { id, chapter } = useParams();

    /* Sending data to useState to use it on page*/
    useEffect(() => {
        const getManga = async () => {
            await fetchManga();
        };
        getManga();
    }, []);

    /* Fetching from a URL data */
    const fetchManga = async () => {
        const res = await fetch("https://shynden.netlify.app/gu1.json", {
            headers: {
                "Access-Control-Allow-Origin": "application/json",
                "Content-Type": "application/json",
                Accept: "application/json",
            },
        });
        const data = await res.json();
        const result = data.data.filter((item) => {
            return item.id.toString() === id;
        });

        setMangaFiltred(...result);
    };

    const ChangePage = (e) => {
        window.location.href = "/mangi/" + id + "/" + e.target.value;
    };

    const PreviousChapter = () => {
        if (chapter - 1 <= 0) return;
        var number = chapter - 1;
        window.location.href = "/mangi/" + id + "/" + number;
    };

    const NextChapter = () => {
        var number = parseInt(chapter) + 1;
        window.location.href = "/mangi/" + id + "/" + number;
    };

    return ( 
        <>
            {MangaFiltred && (
                <> 
                    <div>
                        <Helmet>
                            <meta charset="UTF-8" />
                            <title>
                                Shynden {MangaFiltred.title} {chapter}
                            </title>
                        </Helmet>
                    </div>
                    <div key={2} className="manga-center">
                        <div>
                            <button className="button-click left" onClick={PreviousChapter}>
                                Wstecz
                            </button>
                            <select className="Select-chapter" defaultValue={chapter} onChange={ChangePage}>
                                {MangaFiltred.chapters.map((title) => {
                                    return (
                                        <option key={title.id} value={title.id}>
                                            {title.title}
                                        </option>
                                    );
                                })}
                            </select>
                            <button className="button-click right" onClick={NextChapter}>
                                Następny
                            </button>
                        </div>
                        {MangaFiltred.chapters.map((chap) => {
                            return (
                                chapter.toString() === chap.id.toString() &&
                                chap.photos.map((photo) => {
                                    return (
                                        <div>
                                            <img key={chap.id} className="img-manga lazyload" data-src={photo.url} alt={chap.id} />
                                        </div>
                                    );
                                })
                            );
                        })}
                        <div style={{padding: "25px"}}>
                            <button className="button-click left" onClick={PreviousChapter}>
                                Wstecz
                            </button>
                            <button className="button-click right" onClick={NextChapter}>
                                Następny
                            </button>
                        </div>
                    </div>
                </>
            )}
        </>
    );
};

export default Chapters;
